module.exports = __webpack_public_path__ + "static/media/waypoint_c.f08f6481.svg";